import MarqueeSlider from "react-marquee-slider";
import times from "lodash/times";
import tes1 from '../assets/img/Client Logo Pack/AIFF_Logo.svg';
import tes2 from '../assets/img/Client Logo Pack/Alliance_ethio_francis_Logo.svg';
import tes3 from '../assets/img/Client Logo Pack/Awach_Micro_finance_Logo.svg';
import tes4 from '../assets/img/Client Logo Pack/BetKing_Ethiopia_Logo.svg';
import tes5 from '../assets/img/Client Logo Pack/DDI_Ethiopia_Logo.svg';
import tes6 from '../assets/img/Client Logo Pack/Lois_Kids_Clothing_Logo.svg';
import tes7 from '../assets/img/Client Logo Pack/Talary_jewelry_Logo.svg';
import tes8 from '../assets/img/Client Logo Pack/The_Legend_Coffee_Logo.svg';
import tes9 from '../assets/img/Client Logo Pack/Zemach_FM_Logo.svg';

const images = [tes1, tes7, tes2, tes3, tes4, tes5, tes6, tes8, tes9];

const ClientFeedback = () => {
  return (
    <div className="h-auto flex w-full flex-col relative overflow-hidden ">
      {/* Title Section */}
      <div className="text-start ">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 inline-block border-b-4 border-[#FD5F20] pb-2">
          <strong>Our Satisfied Clients</strong>
        </h1>
      </div>

      {/* Scrolling Marquee */}
      <div className="w-full overflow-hidden relative mt-4" >
        {/* Gradient fade edges */}
        <div className="absolute inset-0 z-10 pointer-events-none">
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent"></div>
        </div>

        <MarqueeSlider velocity={12} minScale={0.8} resetAfterTries={200} scatterRandomly={false}>
          {times(3, () =>
            images.map((img, index) => (
              <div 
                key={index} 
                className="flex flex-row px-8 inline-flex items-center w-30 h-28 justify-center gap-8 mt-8"
                // Fixed container size
              >
                <div className="relative w-full h-full flex items-center justify-center ">
                  <img
                    src={img}
                    className="max-h-[80px] w-90  object-contain transition-all duration-300 hover:scale-110"
                    alt={`Ato creative  ${index + 1}`}
                     title={`Ato creative  ${index + 1}`}
                     
                    style={{
                      filter: 'grayscale(100%)',
                      opacity: 0.8,
                      transition: 'filter 0.3s ease, opacity 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.filter = 'grayscale(0%)';
                      e.currentTarget.style.opacity = '1';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.filter = 'grayscale(100%)';
                      e.currentTarget.style.opacity = '0.8';
                    }}
                  />
                </div>
              </div>
            ))
          )}
        </MarqueeSlider>
      </div>
    </div>
  );
};

export default ClientFeedback;